var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnetimeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15175_56073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C8.53711 0 9.375 0.837891 9.375 1.875V3.75H16.875V1.875C16.875 0.837891 17.7129 0 18.75 0C19.7871 0 20.625 0.837891 20.625 1.875V3.75H23.4375C24.9902 3.75 26.25 5.00977 26.25 6.5625V9.375H0V6.5625C0 5.00977 1.25977 3.75 2.8125 3.75H5.625V1.875C5.625 0.837891 6.46289 0 7.5 0ZM0 11.25H26.25V27.1875C26.25 28.7402 24.9902 30 23.4375 30H2.8125C1.25977 30 0 28.7402 0 27.1875V11.25ZM19.2773 17.8711C19.8281 17.3203 19.8281 16.4297 19.2773 15.8848C18.7266 15.3398 17.8359 15.334 17.291 15.8848L11.7246 21.4512L8.9707 18.6973C8.41992 18.1465 7.5293 18.1465 6.98438 18.6973C6.43945 19.248 6.43359 20.1387 6.98438 20.6836L10.7344 24.4336C11.2852 24.9844 12.1758 24.9844 12.7207 24.4336L19.2773 17.8711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15175_56073"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26.25V30H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnetimeIcon);
export default __webpack_public_path__ + "static/media/onetime-icon.312739de3e6f8cca41177d3c61086033.svg";
export { ForwardRef as ReactComponent };